import { Injectable } from '@angular/core';
import { NavigationEnd, Params, Router } from '@angular/router';
import { map, Observable, tap } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BackdropService } from './backdrop.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    private readonly router: Router,
    private readonly backdropService: BackdropService
  ) {}

  public getCurrentRoute$(): Observable<string | null> {
    return this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      tap(() => this.backdropService.setOverlay(null)),
      map((event) => ('url' in event ? event.url : null))
    );
  }

  public goToCategoriesPage(id: number): Promise<boolean> {
    return this.router.navigate([`/browse-categories/${id}`]);
  }

  public goToOrganisationsPage(): Promise<boolean> {
    return this.router.navigate([`/browse-organizations`]);
  }

  public goToEventPage(eventId: number): Promise<boolean> {
    return this.router.navigate(['event', eventId]);
  }

  public goToEventRegistration(id: number): Promise<boolean> {
    return this.router.navigate([`/event-registration/${id}/form`]);
  }

  public goToResultsByCategoryId(ids: number[]): Promise<boolean> {
    return this.goToResults({ categories: ids });
  }

  public goToResultsByOrganizationId(id: number): Promise<boolean> {
    return this.goToResults({ organization_id: id });
  }

  public goToResults(queryParams: Params): Promise<boolean> {
    return this.router.navigate(['results'], {
      queryParams,
      queryParamsHandling: 'merge',
    });
  }

  public updateQueryParams(
    queryParams: Params,
    skipLocationChange: boolean = false
  ): Promise<boolean> {
    return this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      skipLocationChange,
    });
  }
}
